import React, { type PropsWithChildren } from 'react';
import { isCMDBEnabledInEnvironment } from '@atlassian/jira-servicedesk-cmdb-fedramp';
import { isPremiumInstance } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/services/resources/get-data/index.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { CmdbUpsellStoreContainer, CmdbUpsellStoreSubscriber } from '../../../controllers';

/**
 * Will only render children if:
 * - Instance does not have a premium license
 * - User has not already dismissed the banner
 * - CMDB is enabled in Environment (not FedRamp)
 */
export const UpsellVisibilityCheck = (props: PropsWithChildren<{}>) => {
	const tenantContext = useTenantContext();

	if (
		isPremiumInstance(tenantContext) ||
		!tenantContext.atlassianAccountId ||
		!isCMDBEnabledInEnvironment()
	) {
		return null;
	}

	return (
		<CmdbUpsellStoreContainer atlassianAccountId={tenantContext.atlassianAccountId}>
			<CmdbUpsellStoreSubscriber>
				{({ userHasDismissed }) => userHasDismissed === false && props.children}
			</CmdbUpsellStoreSubscriber>
		</CmdbUpsellStoreContainer>
	);
};
